import React from 'react';
import { Configure as InstantSearchConfigure } from 'react-instantsearch';

interface ConfigureProps {
  hitsPerPage?: number;
}

/**
 * Wrapper component for react-instantsearch's Configure widget
 * Sets default search configuration parameters like results per page
 *
 * Note: This component renders nothing to the DOM, it only configures the search
 */
export const Configure: React.FC<ConfigureProps> = ({ hitsPerPage = 12 }) => {
  return (
    <InstantSearchConfigure
      hitsPerPage={hitsPerPage}
      typoTolerance={true}
      minWordSizefor1Typo={3}
      minWordSizefor2Typos={7}
      removeWordsIfNoResults="lastWords"
    />
  );
};
